export const GET_AUCTIONS = "getAuctions";
export const GET_TENDERS = "getTenders";
export const GET_INQUIRY = "getInquiry";
export const POST_INQUIRY_PRICE = "getInquiryPrice";
export const GET_SUPPLIER_PRICE = "supplierPrice";